import React from 'react';

export function PageFooter() {
  return <div>SignerAppPageFooter</div>;
}
